import axios from "axios";
import { service } from "../config";

const Http = axios.create({
	baseURL: service.apipath,
});

Http.interceptors.request.use(function (config) {
	const token = localStorage.getItem('AccessToken');
	config.headers.AccessToken = token;

	return config;
});

Http.interceptors.response.use((response) => {
	return response;
}, (error) => {
	if (error.response.data.HTTPStatusCode === 400 || error.response.data.HTTPStatusCode === 409 || error.response.data.status === 404) {
		if (error.response.data.Code === 'Errors.Editor.NoHTMLExist') {
			return 'NoHTMLExist';
		}
		if (error.response.data.Code.includes('Errors.Cafe24')) {
			return Promise.reject(error);
		}
		if (error.response.data.Code !== 'Errors.List.AccessDenied') {
			window.parent.postMessage({msg: 'reboot'}, '*');
			return;
		}
	}

	if (error.response.data.Code === 'Errors.Authorization.NoToken') {
		window.parent.postMessage({msg: 'reboot'}, '*');
		return;
	}
	
	if (error.response.data.msg === 'invalid_token' || error.response.data.msg === 'auth fail') {
		// 부모창에 토큰 요청하기
		window.parent.postMessage({msg: 'reboot'}, '*');
		// window.location.href = `/login?redirect=${window.location.pathname}`;
		return Promise.reject(error);
	}
	return Promise.reject(error);
});

export default Http;
